import { defineStore } from 'pinia';

export const useMobileStore = defineStore('mobile', () => {
  const showMenu = ref();

  const toggleMenu = (show: boolean): void => {
    showMenu.value = show !== null ? show : !showMenu.value;
  };

  return {
    showMenu,

    toggleMenu,
  };
});
